import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-payment-requests-admin',
  imports: [RouterModule],
  templateUrl: './payment-requests-admin.html',
})
export class PaymentRequestsAdmin {

}
